// TermsOfService.jsx

import React, { useEffect } from "react";
import {
  ArrowLeft,
  ShieldCheck,
  FileText,
  Lock,
  Users,
  Scale,
  Globe,
  Database,
  CreditCard,
  AlertTriangle,
  Gavel,
  Phone,
  Mail,
  RefreshCw,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const TermsOfService = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  const sections = [
    {
      icon: <FileText size={22} />,
      title: "Acceptance of Terms",
      content:
        "Thanks for using Drivault. These Terms of Service govern your access to and use of Drivault websites, applications, software, APIs, and cloud storage services. By accessing or using our Services, you agree to be bound by these Terms, our Privacy Policy, Cookie Policy, and Acceptable Use guidelines.",
    },

   {
  icon: <Database size={22} />,
  title: "Your Stuff  & Your Permissions",
  content: (
    <div className="space-y-6">

      <p>
        When you use our Services, you provide us with
        things like your files, content, messages,
        contacts, connected services, and other data
        (“Your Content”). Your Content remains yours.
        These Terms do not give Drivault any ownership
        rights to Your Content except for the limited
        rights necessary to provide and operate the
        Services.
      </p>

      <p>
        You may need to register for an account to
        access certain Services, and we may create
        an account for you so you can interact with
        our platform and applications.
      </p>

      <p>
        Our Services may include multiple applications,
        platforms, and websites. To help improve your
        productivity and experience, when you use the
        same account across different Drivault Services,
        Your Content may remain accessible throughout
        the platform.
      </p>

      <p>
        We require your permission to perform actions
        such as hosting, storing, backing up, processing,
        and sharing Your Content when requested by you.
        Our Services may also provide features such as
        file previews, commenting, sharing, searching,
        organization tools, document previews, image
        thumbnails, optical character recognition (OCR),
        and personalization features designed to improve
        your workflow and experience.
      </p>

      <p>
        To provide these features and improve the
        Services, Drivault may access, process,
        store, and scan Your Content. You grant
        Drivault permission to perform these actions,
        and this permission extends to our affiliates,
        infrastructure providers, and trusted third-party
        partners who help us operate, secure, improve,
        and support the Services.
      </p>

    </div>
  ),
},

{
  icon: <ShieldCheck size={22} />,
  title: "Data Protection & Privacy",
  content: `Drivault processes personal data in accordance with applicable Indian laws, including the Digital Personal Data Protection Act, 2023 and the Information Technology Act, 2000. By using our Services, you consent to the collection, processing, storage, and use of your information as described in our Privacy Policy.`
},

      {
  icon: <Database size={22} />,
  title: "Your Responsibilities",
  content: (
    <div className="space-y-6">

      <p>
        Your use of our Services must comply with our Acceptable Use Policy. Content in the Services may be protected by others’ intellectual property rights. Please don’t copy, upload, download, or share content unless you have the right to do so.
      </p>

      <p>
       Drivault may review your conduct and content for compliance with these Terms and our Acceptable Use Policy. We aren’t responsible for the content people post and share via the Services.
      </p>

      <p>
      Help us keep Your Stuff protected. Safeguard your password to the Services, and keep your account information current. Don’t share your account credentials or give others access to your account.
      </p>

      <p>
        You may use our Services only as permitted by applicable law, including applicable laws and regulations of India Finally, to use our Services, You must be at least 18 years old to create an account and use our Services independently. If you are under 18, you may use the Services only with the involvement and consent of a parent or legal guardian, where permitted under applicable law. if you reside anywhere else. If the law where you reside requires that you must be older in order for Drivault to lawfully provide the Services to you without parental consent (including use of your personal data), then you must be that older age.
      </p>
    </div>
  ),
},

{
      icon: <Lock size={22} />,
      title: "Software",
      content:
"Some of our Services allow you to download client software (“Software”) which may update automatically. So long as you comply with these Terms, we give you a limited, nonexclusive, nontransferable, revocable license to use the Software, solely to access the Services. To the extent any component of the Software may be offered under an open source license, we’ll make that license available to you and the provisions of that license may expressly override some of these Terms. Unless the following restrictions are prohibited by law, you agree not to reverse engineer or decompile the Services, attempt to do so, or assist anyone in doing so."
    },

    {
      icon: <FileText size={22} />,
      title: "Beta Services",
       content: (
    <div className="space-y-6">

      <p>
        We sometimes release products and features that we’re still testing and evaluating (“Beta Services”). Beta Services are labeled “alpha,” “beta,” “preview,” “early access,” or “evaluation” (or with words or phrases with similar meanings) and may not be as reliable as Drivalut other services. Beta Services are made available so that we can collect user feedback, and by using our Beta Services, you agree that we may contact you to collect such feedback.      </p>

      <p>
Beta Services are confidential until official launch. If you use any Beta Services, you agree not to disclose any information about those Services to anyone else without our permission      </p>
    </div>
  ), },


   {
    icon: <ShieldCheck size={22} />,
      title: "Electronic Signatures",
      content:
"By using a part of the Services that facilitates electronic signatures, you agree to do business electronically and to use electronic records and signatures. There may be laws where you reside governing what types of documents and transactions are appropriate for such signatures. It’s your responsibility to ensure that the electronic signature functionality provided by the Services is appropriate for your scenario."
    },


     {
      icon: <Lock size={22} />,
      title: "Fax Services",
       content: (
    <div className="space-y-6">

      <p>
The Services may include sample templates and forms (“Templates”). Templates are for informational purposes only. We are not attorneys or a law firm, and our Templates are not a substitute for the advice or services of an attorney. You acknowledge that Drivault is not providing you with legal advice or acting as your attorney or agent, and you assume full responsibility for any outcomes or costs associated with your use of our Templates.          </p>

      <p>
Drivault does not claim that documents based on the Templates are complete and suitable for use in all situations and jurisdictions. You should consult with an attorney about your specific situation before relying on the Templates for any contract, agreement or transaction. You hereby acknowledge that Drivault is not a party to any agreement that you enter into as a result of the use of any document that you create or use through the Services. Use of the Services and any document (including any document based on the Templates) does not constitute an attorney-client relationship, joint venture or partnership between Drivault and any user or third party. Communications between you and Drivault are governed by these Terms and our Privacy Policy but are not protected by the attorney-client privilege or as work product.    </p>
    </div>
  ), },
    

    {
     icon: <FileText size={22} />,
      title: "Templates and Forms",
       content: (
    <div className="space-y-6">

      <p>
If you use a part of the Services that facilitates faxing, you may be required to provide information such as your name, billing address, physical address, payment information (including credit card number), and national ID number (where applicable). Failure to provide this information could result in suspension of your access.
 </p>

      <p>
You may not use our Services to send unsolicited fax advertisements or spam, and we may decide to not deliver any messages we consider unsolicited fax advertisements or spam.
 </p>
 <p>
We cannot guarantee that any particular fax number will be available for you to use. If you stop using our fax services, your number may be released or reassigned to another customer. In the US, UK, and Canada, we may support porting a fax number (both in and out) for an additional fee.
 </p>
    </div>
  ), },
    {
      icon: <Lock size={22} />,
      title: "Third-Party Features",
      content:
"The Services may give you the option to link to third-party features and integrations. Drivault does not own or operate any such features or integrations. If you access or use any third-party features or integrations, you are responsible for this access and use, and Drivault is not responsible for any act or omission of the third party or the availability, accuracy, the related content, products or services of third parties."
    },

     {
      icon: <FileText size={22} />,
      title: "Our Stuff",
      content:
"The Services are protected by applicable intellectual property laws, including the Copyright Act, 1957 and trademark laws of India and other applicable jurisdictions.These Terms don’t grant you any right, title, or interest in the Services, others’ content in the Services, Drivault trademarks, logos and other brand features. We welcome feedback, but note that we may use comments or suggestions without any obligation to you."
    },

    {
  icon: <ShieldCheck size={22} />,
  title: "Copyright",
  content: (
    <div className="space-y-6">

      <p>
        We respect the intellectual property of others
        and ask that you do too. We respond to notices
        of alleged copyright infringement if they comply
        with applicable law, and such notices should be
        reported using our Copyright Policy.
      </p>

      <p>
        We reserve the right to delete or disable content
        alleged to be infringing and terminate accounts
        of repeat infringers.
      </p>

      <p>
        Copyright infringement claims should be submitted
        using our Copyright Complaint Form or submitted
        to our designated agent for our Services at:
      </p>

      <div className="bg-[#F8FAFC] border border-slate-200 rounded-2xl p-5 leading-8 text-slate-700">
        <p className="font-semibold">
          Copyright Agent
        </p>

        <p>
          Drivault
        </p>

        <p>
          Outofbox Cloud Private Limited
        </p>

        <p>
          4th Floor, Oneness,
          Sadashivnagar, Belagavi,
          Karnataka, India 590001
        </p>

        <p>
          copyright@drivault.com
        </p>
      </div>

    </div>
  ),
},

{
  icon: <CreditCard size={22} />,
  title: "Paid Accounts",
  content: (
    <div className="space-y-6">

      <div>
        <h3 className="text-xl font-semibold mb-3">
          Billing
        </h3>

        <p>
          You can increase your storage space and add
          paid features to your account (turning your
          account into a “Paid Account”). We’ll
          automatically bill you from the date you
          convert to a Paid Account and on each periodic
          renewal until cancellation.
        </p>

        <p className="mt-4">
          If you’re on an annual plan, we’ll send you
          a notice email reminding you that your plan
          is about to renew within a reasonable period
          of time prior to the renewal date.
        </p>

        <p className="mt-4">
          You’re responsible for all applicable taxes,
          and we’ll charge tax when required to do so.
          Some countries have mandatory local laws
          regarding your cancellation rights, and this
          paragraph doesn’t override those laws.
        </p>
      </div>

      <div>
        <h3 className="text-xl font-semibold mb-3">
          Cancellation
        </h3>

        <p>
          You may cancel your Paid Account at any time.
          Refunds are only issued if required by law.
          For example, users living in certain regions
          may have the right to cancel Paid Account
          subscriptions and obtain a refund within a
          legally required cancellation period.
        </p>
      </div>

      <div>
        <h3 className="text-xl font-semibold mb-3">
          Downgrades
        </h3>

        <p>
          Your Paid Account will remain in effect until
          it is cancelled or terminated under these
          Terms. If you don’t pay for your Paid Account
          on time, we reserve the right to suspend it
          or remove Paid Account features.
        </p>
      </div>

      <div>
        <h3 className="text-xl font-semibold mb-3">
          Changes
        </h3>

        <p>
          We may change the fees in effect on renewal
          of your subscription to reflect changes to
          our products, business operations, or economic
          conditions.
        </p>

        <p className="mt-4">
          We’ll give you no less than 30 days’ advance
          notice of these changes via a message to the
          email address associated with your account,
          and you’ll have the opportunity to cancel
          your subscription before the new fee comes
          into effect.
        </p>
      </div>

    </div>
  ),
},

{
  icon: <Users size={22} />,
  title: "Drivault Teams",
  content: (
    <div className="space-y-6">

      <div>
        <h3 className="text-xl font-semibold mb-3">
          Email Address
        </h3>

        <p>
          If you sign up for a Drivault account with
          an email address provided by your organization,
          your organization may be able to block your
          use of Drivault until you transition to an
          account on a Drivault Team or associate your
          Drivault account with a personal email address.
        </p>
      </div>

      <div>
        <h3 className="text-xl font-semibold mb-3">
          Using Drivault Teams
        </h3>

        <p>
          If you join a Drivault Team, you must use
          it in compliance with your organization’s
          terms and policies.
        </p>

        <p className="mt-4">
          Please note that Drivault Team accounts are
          subject to your organization’s control.
          Your administrators may be able to access,
          disclose, restrict, or remove information
          in or from your Drivault Team account.
        </p>

        <p className="mt-4">
          They may also be able to restrict or terminate
          your access to a Drivault Team account.
          If you convert an existing Drivault account
          into part of a Drivault Team, your administrators
          may prevent you from later disassociating your
          account from the Drivault Team.
        </p>
      </div>

    </div>
  ),
},

{
  icon: <AlertTriangle size={22} />,
  title: "Termination",
  content: (
    <div className="space-y-6">

      <p>
        You’re free to stop using our Services at any
        time. We reserve the right to suspend or
        terminate your access to the Services with
        notice to you if Drivault reasonably believes:
      </p>

      <ul className="list-disc pl-6 space-y-3">
        <li>
          You’re in breach of these Terms.
        </li>

        <li>
          Your use of the Services would cause a real
          risk of harm or loss to us or other users.
        </li>

        <li>
          You don’t have a Paid Account and haven’t
          accessed our Services for 12 consecutive
          months.
        </li>
      </ul>

      <p>
        We’ll provide you with reasonable advance
        notice via the email address associated with
        your account to remedy the activity that
        prompted us to contact you and give you the
        opportunity to export Your Content from our
        Services.
      </p>

      <p>
        If after such notice you fail to take the
        steps we ask of you, we’ll terminate or
        suspend your access to the Services.
      </p>

      <p>
        We won’t provide notice or an opportunity to
        export Your Content before termination or
        suspension of access to the Services where
        Drivault reasonably believes:
      </p>

      <ul className="list-disc pl-6 space-y-3">
        <li>
          You’re in material breach of these Terms,
          including but not limited to violating our
          Acceptable Use Policy.
        </li>

        <li>
          Doing so would cause us legal liability or
          compromise our ability to provide the
          Services to our other users.
        </li>

        <li>
          We’re prohibited from doing so by law.
        </li>
      </ul>

      <p>
        Once we suspend or terminate your access to
        the Services, you will not be able to access
        or export Your Content.
      </p>

      <p>
        Drivault does not provide refunds if we suspend
        or terminate your access to the Services unless
        required by law.
      </p>

    </div>
  ),
},

{
  icon: <RefreshCw size={22} />,
  title: "Discontinuation of Services",
  content: (
    <div className="space-y-6">

      <p>
        We may decide to discontinue the Services in
        response to exceptional unforeseen circumstances,
        events beyond Drivault’s control (for example,
        natural disasters, fire, or technical failures),
        or to comply with legal requirements.
      </p>

      <p>
        If we do so, we’ll give you reasonable prior
        notice so that you can export Your Content
        from our systems.
      </p>

      <p>
        Where possible under the circumstances, we
        will provide no less than 30 days’ notice.
      </p>

      <p>
        If we discontinue the Services before the end
        of any fixed or minimum term you have paid
        for, we’ll refund the portion of the fees you
        have prepaid but haven’t received Services for.
      </p>

    </div>
  ),
},


{
    icon: <ShieldCheck size={22} />,
     icon: <AlertTriangle size={22} />,
  title: "Services “AS IS”",
  content: `We strive to provide great Services, but there are certain things that we can't guarantee. To the extent permitted under applicable law,, DRIVAULT AND ITS AFFILIATES, SUPPLIERS AND DISTRIBUTORS MAKE NO WARRANTIES, EITHER EXPRESS OR IMPLIED, ABOUT THE SERVICES. THE SERVICES ARE PROVIDED "AS IS." WE ALSO DISCLAIM ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. Some places don’t allow the disclaimers in this paragraph, so they may not apply to you. For example, these disclaimers do not override the legal protections, including statutory warranties, granted to consumers by applicable law.
`,
},

{
     icon: <FileText size={22} />,
  title: "Limitation of Liability",
  content: `Nothing in these Terms limits or excludes liability where such limitation or exclusion is prohibited under applicable law. Subject to applicable law, Drivault shall not be liable for indirect, incidental, consequential, or special damages arising from the use or inability to use the Services..

IN COUNTRIES WHERE EXCLUSIONS OR LIMITATIONS OF LIABILITY ARE ALLOWED, DRIVAULT, ITS AFFILIATES, SUPPLIERS OR DISTRIBUTORS WON’T BE LIABLE FOR:

• ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, EXEMPLARY, OR CONSEQUENTIAL DAMAGES, OR  
• ANY LOSS OF USE, DATA, BUSINESS, OR PROFITS, REGARDLESS OF LEGAL THEORY.

THESE EXCLUSIONS OR LIMITATIONS WILL APPLY REGARDLESS OF WHETHER OR NOT DRIVAULT OR ANY OF ITS AFFILIATES HAS BEEN WARNED OF THE POSSIBILITY OF SUCH DAMAGES.

IF YOU USE THE SERVICES FOR ANY COMMERCIAL, BUSINESS, OR RE-SALE PURPOSE, DRIVAULT, ITS AFFILIATES, SUPPLIERS OR DISTRIBUTORS WILL HAVE NO LIABILITY TO YOU FOR ANY LOSS OF PROFIT, LOSS OF BUSINESS, BUSINESS INTERRUPTION, OR LOSS OF BUSINESS OPPORTUNITY. DRIVAULT AND ITS AFFILIATES AREN’T RESPONSIBLE FOR THE CONDUCT, WHETHER ONLINE OR OFFLINE, OF ANY USER OF THE SERVICES.

OTHER THAN FOR THE TYPES OF LIABILITY WE CANNOT LIMIT BY LAW (AS DESCRIBED IN THIS SECTION), WE LIMIT OUR LIABILITY TO YOU TO THE GREATER OF ₹1,500 INR OR 100% OF ANY AMOUNT YOU'VE PAID UNDER YOUR CURRENT SERVICE PLAN WITH DRIVAULT.
`,
},

{
    icon: <Database size={22} />,
  title: "Resolving Disputes",
  content:`Let’s Try to Sort Things Out First. We want to address your concerns without needing a formal legal case. Before filing a claim against Drivault, you agree to try to resolve the dispute informally by sending us a written Notice of Dispute at support@drivault.com that includes your name, a detailed description of the dispute, and the relief you seek. We’ll try to resolve the dispute informally by contacting you via email. If a dispute is not resolved within 60 days after submission, you or Drivault may bring a formal proceeding.

Judicial Forum for Disputes. You and Drivault agree that any judicial proceeding to resolve claims relating to these Terms or the Services will be brought in the courts of Belagavi, Karnataka, India. Both you and Drivault consent to venue and personal jurisdiction in such courts.

We Both Agree to Arbitrate. You and Drivault agree to resolve any claims relating to or arising out of these Terms or the Services through final and binding individual arbitration by a single arbitrator, except as set forth under the “Exceptions to Agreement to Arbitrate” below.

Opt out of Agreement to Arbitrate. You can decline this agreement to arbitrate by contacting support@drivault.com within 30 days of first registering your account or agreeing to these Terms.

Arbitration Procedures. Any dispute arising out of or relating to these Terms shall be resolved through arbitration in accordance with the Arbitration and Conciliation Act, 1996 of India. The seat and venue of arbitration shall be Belagavi, Karnataka, India. Proceedings shall be conducted in English. The arbitration will be held in Belagavi, Karnataka, India, or any other location agreed upon by both parties.

Arbitration Fees and Incentives. Arbitration fees shall be allocated in accordance with applicable arbitration rules and laws. Drivault may reimburse reasonable arbitration filing fees where required by law.

Exceptions to Agreement to Arbitrate. Nothing in these Terms prevents either party from seeking interim or injunctive relief from a competent court in India.

NO CLASS OR REPRESENTATIVE ACTIONS. You may only resolve disputes with us on an individual basis, and may not bring a claim as a plaintiff or a class member in a class, consolidated, or representative action.

Severability. If any part of this “Mandatory Arbitration Provisions” section is found to be illegal or unenforceable, the remainder will remain in effect.
`,
},

{
    icon: <Database size={22} />,
  title: "Controlling Law",
content: `These Terms shall be governed and interpreted in accordance with the laws of India. Any disputes arising out of or relating to these Terms or the Services shall be subject to the jurisdiction of the courts located in Belagavi, Karnataka, India.`
},


{
    icon: <FileText size={22} />,
  title: "Entire Agreement",
  content: `These Terms constitute the entire agreement between you and Drivault with respect to the subject matter of these Terms, and supersede and replace any other prior or contemporaneous agreements, or terms and conditions applicable to the subject matter of these Terms. Our past, present, and future affiliates and agents can invoke our rights under this agreement in the event they become involved in a dispute with you. Otherwise, these Terms do not give rights to any third parties.`,
},

{
    icon: <FileText size={22} />,
  title: "Waiver, Severability & Assignment",
  content: `Drivault’s failure to enforce a provision is not a waiver of its right to do so later. If a provision is found unenforceable, the remaining provisions of these Terms will remain in full effect and an enforceable term will be substituted reflecting our intent as closely as possible. You may not assign any of your rights under these Terms, and any such attempt will be void. Drivault may assign its rights to any of its affiliates or subsidiaries, or to any successor in interest of any business associated with the Services.
`,
},

{
    icon: <FileText size={22} />,
  title: "Modifications",
  content: `We may revise these Terms to better reflect:

• changes to the law,  
• new regulatory requirements,  
• improvements or enhancements made to our Services.

If an update affects your use of the Services or your legal rights as a user of our Services, we’ll notify you prior to the update's effective date by sending an email to the email address associated with your account or via an in-product notification. These updated terms will become effective no less than 30 days from when we notify you.

If you don’t agree to the updates we make, please cancel your account and stop using the Services before the updated Terms become effective. Where applicable, we may offer you a prorated refund based on the amounts you have prepaid for Services and your account cancellation date. By continuing to use or access the Services after the updates come into effect, you agree to be bound by the revised Terms.
`,
},



  ];

  return (
    <div className="min-h-screen bg-[#F6F9FC] text-[#0F172A] overflow-hidden">

      {/* Background Effects */}
      <div className="absolute top-0 left-0 w-full h-[400px] bg-gradient-to-b from-[#40E095]/10 via-[#40E095]/5 to-transparent pointer-events-none" />

      <div className="absolute top-40 right-[0px] w-[350px] h-[350px] bg-[#40E095]/10 blur-3xl rounded-full pointer-events-none" />

      <div className="absolute bottom-0 left-[-120px] w-[350px] h-[350px] bg-emerald-200/20 blur-3xl rounded-full pointer-events-none" />

      <div className="relative max-w-6xl mx-auto px-6 py-14">

        {/* Back Button */}
        <button
          onClick={() => {
            navigate("/");

            setTimeout(() => {
              window.scrollTo({
                top: 0,
                behavior: "instant",
              });
            }, 0);
          }}
          className="flex items-center gap-2 text-gray-500 hover:text-[#40E095] transition-all duration-300 mb-10"
        >
          <ArrowLeft size={20} />

          <span className="font-medium">
            Back
          </span>
        </button>

        {/* HERO */}
        <div className="relative bg-white/90 backdrop-blur-xl border border-white shadow-[0_10px_40px_rgba(0,0,0,0.05)] rounded-[28px] overflow-hidden mb-6">

          <div className="absolute top-0 right-0 w-[180px] h-[180px] bg-[#40E095]/10 blur-3xl rounded-full" />

          <div className="relative p-5 md:p-8">

            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">

              {/* Left */}
              <div className="max-w-3xl">

                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
                  Terms of{" "}
                  <span className="text-[#40E095]">
                    Service
                  </span>
                </h1>

                <p className="mt-4 text-base md:text-lg text-slate-600 leading-7 max-w-3xl">
                  These Terms of Service explain the rules,
                  responsibilities, rights, and conditions for
                  using Drivault websites, applications,
                  cloud storage services, and related
                  technologies.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-6">

                  <div className="bg-[#F8FAFC] border border-slate-200 rounded-2xl p-4">
                    <p className="text-xs text-slate-500 mb-1">
                      Posted
                    </p>

                    <p className="font-semibold text-base">
                      May 9, 2026
                    </p>
                  </div>

                  <div className="bg-[#F8FAFC] border border-slate-200 rounded-2xl p-4">
                    <p className="text-xs text-slate-500 mb-1">
                      Effective
                    </p>

                    <p className="font-semibold text-base">
                      May 9, 2026
                    </p>
                  </div>

                </div>
              </div>

              {/* Right Card */}
              <div className="w-full lg:max-w-[320px]">

                <div className="bg-[#0F172A] text-white rounded-3xl p-6 shadow-xl relative overflow-hidden">

                  <div className="absolute top-0 right-0 w-28 h-28 bg-[#40E095]/20 blur-3xl rounded-full" />

                  <div className="relative">

                    <div className="w-14 h-14 rounded-2xl bg-[#40E095]/15 border border-[#40E095]/30 flex items-center justify-center mb-4">
                      <ShieldCheck
                        size={28}
                        className="text-[#40E095]"
                      />
                    </div>

                    <h3 className="text-xl font-bold mb-3">
                      Drivault
                    </h3>

                    <div className="space-y-3 text-slate-300 leading-6 text-sm">

                      <p>
                        Outofbox Cloud Private Limited
                      </p>

                      <p>
                        4th Floor, Oneness,
                        Sadashivnagar, Belagavi,
                        Karnataka, India 590001
                      </p>

                      <div className="pt-3 border-t border-white/10">

                        <div className="flex items-center gap-2 mb-2">
                          <Phone size={15} />
                          <span>
                            6363-900-800
                          </span>
                        </div>

                        <div className="flex items-center gap-2">
                          <Mail size={15} />
                          <span className="break-all">
                            support@drivault.com
                          </span>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* CONTENT */}
        <div className="grid gap-8">
          {sections.map((section, index) => (
            <div
              key={index}
              className="group bg-white/90 backdrop-blur-xl border border-white shadow-[0_10px_50px_rgba(0,0,0,0.05)] hover:shadow-[0_20px_60px_rgba(64,224,149,0.12)] transition-all duration-500 rounded-[28px] p-8 md:p-10"
            >
              <div className="flex items-start gap-5">

                <div className="min-w-[60px] w-[60px] h-[60px] rounded-2xl bg-[#40E095]/10 border border-[#40E095]/20 flex items-center justify-center text-[#40E095] group-hover:scale-110 transition-transform duration-300">
                  {section.icon}
                </div>

               <div>

            <h2 className="text-2xl md:text-3xl font-bold mb-2 tracking-tight leading-tight">
                {section.title}
            </h2>

            <div className="text-slate-600 leading-7 text-[17px] whitespace-pre-line space-y-2">
                {typeof section.content === "string"
                ? section.content
                : section.content}
            </div>

            </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default TermsOfService;